var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnUploadImg2 = function SvgIcnUploadImg2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7.00006H33C34.6569 7.00006 36 8.34321 36 10.0001V28.9994C36 28.9998 36 29.0003 36 29.0008V30.0001C36 31.6569 34.6569 33.0001 33 33.0001H7C5.34315 33.0001 4 31.6569 4 30.0001V25.9958C4 25.9957 4 25.9956 4 25.9955V10.0001C4 8.34321 5.34315 7.00006 7 7.00006ZM6 26.41V30.0001C6 30.5523 6.44772 31.0001 7 31.0001H33C33.5523 31.0001 34 30.5523 34 30.0001V29.4142L26.6417 22.0543L22.7702 24.8183C22.0215 25.3527 21.0126 25.3043 20.3202 24.7208L20.1942 24.6051L13.9997 18.4143L6 26.41ZM34 26.5855L28.0561 20.6402L27.9301 20.5245C27.2377 19.9405 26.2284 19.8919 25.4796 20.4265L21.6081 23.1905L15.4142 16.9997L15.2869 16.883C14.5006 16.2218 13.3265 16.2607 12.5864 16.9991L6 23.5823V10.0001C6 9.44778 6.44772 9.00006 7 9.00006H33C33.5523 9.00006 34 9.44778 34 10.0001V26.5855ZM31 14.5001C31 15.8808 29.8807 17.0001 28.5 17.0001C27.1193 17.0001 26 15.8808 26 14.5001C26 13.1193 27.1193 12.0001 28.5 12.0001C29.8807 12.0001 31 13.1193 31 14.5001Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnUploadImg2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_upload_img2.d68d2b3c.svg";
export { ForwardRef as ReactComponent };